<div class="flex h-20 shrink-0 items-center gap-4 border-b border-gray-200 pl-8 pr-6">
  <app-button2
    data-test="kp-results-type"
    class="min-w-0 [&>button]:min-w-0"
    appearance="secondary"
    size="m"
    [class]="menuOpened() ? '[&>button]:border-primary-600 [&>button]:text-primary-600' : ''"
    [disabled]="disabled()"
    [appKPStitchTypeContextMenu]="stateKey()"
    [appKPStitchTypeContextMenuCounts]="menuCounts()"
    [stchPopoverDisabled]="disabled()"
    (appKPStitchTypeContextMenuOpened)="handleMenuOpened($event)"
    (appKPStitchTypeContextMenuChange)="typeChange.emit($event)"
  >
    <app-icon class="shrink-0" [name]="entry().icon" [size]="20" />
    <span data-test="kp-results-type-label" class="truncate text-base">{{ entry().label }}</span>
    <app-kp-count-badge data-test="kp-results-type-count" [count]="count()" />
    <app-icon
      data-test="kp-results-type-chevron"
      class="shrink-0 transition-transform"
      name="sapphire-chevron-down"
      [size]="16"
      [class.rotate-180]="menuOpened()"
    />
  </app-button2>

  <!--
    Sort & filter at the row's end (stitch-app-shell `FilterIconTrigger`): the section's filter icon, and
    once a filter is applied the Blue/50 capsule round it with a × that clears it.
  -->
  <div class="kp-filter-group ml-auto flex shrink-0 items-center" [class.applied]="filtersActive()">
    <ng-content />

    @if (filtersActive()) {
      <span class="kp-filter-divider" aria-hidden="true"></span>
      <button
        type="button"
        data-test="kp-results-clear-filters"
        class="kp-filter-clear"
        aria-label="Clear filters"
        matTooltip="Clear filters"
        (click)="clearFilters()"
      >
        <app-icon name="close" [size]="16" />
      </button>
    }
  </div>
</div>
